
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  display:block;
}

:host([site='GHS']) .hero-banner-body-section {
  background-color:var(--primary-blue);
}

:host([site='GHS']) .hero-banner-title{
    font-family:var(--ff-display);
  }

:host([site='GHS']) .hero-banner-title h1{
      font-size:inherit;
      font-weight:inherit;
      margin:inherit;
    }

:host([site='GHS']) .hero-banner-body-text{
    font-family:var(--ff-body);
  }

:host([site='GHS']) .hero-banner-background.alternate {
  padding-top:1.75rem;
}

@media (min-width: 768px) {

  :host([site='GHS']) .hero-banner-background.alternate {
    padding-top:4rem;
  }
}

:host([site='BH']) .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
  background-color:var(--bh-brand-primary-default);
}

:host .hero-banner {
  background-color:var(--neutral-transparent);
}

:host .hero-banner {
  color:var(--bh-neutral-white);
}

:host .hero-banner-content-section {
  font-family:var(--bh-ff-body);
}

:host .hero-banner-content-section {
  font-size:var(--bh-fs-body-03);
  line-height:var(--bh-lh-body-03);
  letter-spacing:var(--bh-ls-body-03);
}

:host .hero-banner-content-section {
  font-weight:var(--fw-normal);
}

:host .hero-banner-eyebrow {
  margin-bottom:0.5rem;
}

:host .hero-banner-eyebrow {
  font-size:var(--bh-fs-heading-02);
  line-height:var(--bh-lh-heading-02);
  letter-spacing:var(--bh-ls-heading-02);
}

:host .hero-banner-eyebrow {
  font-weight:var(--fw-bold);
}

:host .hero-banner-title {
  margin-bottom:1rem;
}

:host .hero-banner-title {
  overflow-wrap:break-word;
}

:host .hero-banner-title {
  font-size:var(--bh-fs-heading-06);
  line-height:var(--bh-lh-heading-06);
  letter-spacing:var(--bh-ls-heading-06);
}

:host .hero-banner-title {
  font-weight:var(--fw-light);
}

@media (min-width: 768px) {

  :host .hero-banner-title {
    overflow-wrap:normal;
    word-break:normal;
  }
}

:host .hero-banner-title h1{
      font-size:inherit;
      font-weight:inherit;
      margin:inherit;
    }

:host .hero-banner-body-text {
  margin-bottom:1.5rem;
}

@media (min-width: 2180px) {

  :host .hero-banner:not(.basic-interior-hero):not(.full-width) outline-container {
    max-width:101rem;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero) {
    background-image:var(--bh-gradient-gray-b-t);
  }
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-content-section {
  display:flex;
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-content-section {
  flex-direction:column-reverse;
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
    width:100%;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero).right-align .hero-banner-body-section {
    margin-left:-14rem;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero).right-align .hero-banner-content-section {
    flex-direction:row-reverse;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero).left-align .hero-banner-body-section {
    margin-right:-14rem;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero).left-align .hero-banner-content-section {
    flex-direction:row;
  }
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
  z-index:10;
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
  border-bottom-right-radius:0.5rem;
  border-bottom-left-radius:0.5rem;
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
  padding-left:1rem;
  padding-right:1rem;
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
  padding-top:1.5rem;
  padding-bottom:1.5rem;
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
    margin-top:auto;
    margin-bottom:auto;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
    height:fit-content;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
    max-width:610px;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
    border-radius:0.5rem;
  }
}

@media (min-width: 1280px) {

  :host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
    padding-left:3rem;
    padding-right:3rem;
  }
}

@media (min-width: 1280px) {

  :host .hero-banner:not(.basic-interior-hero) .hero-banner-body-section {
    padding-top:2rem;
    padding-bottom:2rem;
  }
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-breadcrumb {
  margin-bottom:0.75rem;
}

@media (min-width: 640px) {

  :host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons'] {
    flex-direction:row;
  }
}

@media (min-width: 640px) {

  :host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons'] {
    flex-wrap:wrap;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons'] {
    gap:3rem;
  }
}

:host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons']:has(:nth-child(2n + 3)), :host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons']:not(:has(> [variant='cta-light'])) {
  gap:1rem;
}

:host .hero-banner:not(.basic-interior-hero) [variant='cta-light'] {
  margin-left:0.25rem;
}

@media (min-width: 640px) {

  :host .hero-banner:not(.basic-interior-hero) [variant='cta-light'] {
    margin-left:0px;
  }
}

:host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons']:has(:nth-child(2n + 3)) [variant='cta-light'] {
  margin-top:0.5rem;
}

:host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons']:has(:nth-child(2n + 3)) [variant='cta-light'] {
  margin-left:0.25rem;
}

:host .hero-banner:not(.basic-interior-hero) [slot='hero-banner-buttons']:has(:nth-child(2n + 3)) [variant='cta-light'] {
  flex-basis:100%;
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-hero-image {
  width:100%;
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-hero-image.alternate img {
  border-bottom-right-radius:0px;
  border-bottom-left-radius:0px;
}

:host .hero-banner:not(.basic-interior-hero) .hero-banner-hero-image img {
  border-top-left-radius:0.5rem;
  border-top-right-radius:0.5rem;
}

:host .full-width:not(.basic-interior-hero) .hero-banner-hero-image img {
  border-radius:0px;
}

:host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
  top:0px;
}

:host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
  bottom:0px;
}

:host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
  margin-left:1rem;
  margin-right:1rem;
}

:host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
  margin-top:-2rem;
}

:host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
  border-radius:0.5rem;
}

@media (min-width: 1024px) {

  :host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
    position:absolute;
  }
}

@media (min-width: 1024px) {

  :host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
    margin-top:auto;
  }
}

@media (min-width: 1024px) {

  :host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
    max-width:490px;
  }
}

@media (min-width: 1280px) {

  :host .full-width:not(.basic-interior-hero) .hero-banner-body-section {
    margin-left:140px;
    margin-right:140px;
  }
}

:host .full-width:not(.basic-interior-hero) .hero-banner-content-section {
  position:relative;
}

@media (min-width: 1024px) {

  :host .full-width:not(.basic-interior-hero) .hero-banner-content-section {
    display:block;
  }
}

@media (min-width: 1024px) {

  :host .full-width:not(.basic-interior-hero).right-align .hero-banner-body-section {
    right:0px;
  }
}

:host .hero-banner.basic-interior-hero {
  color:var(--bh-neutral-black);
}

:host .hero-banner.basic-interior-hero:not(.hero-banner-form-full-bleed) .hero-banner-body-section {
  border-width:0px;
}

:host .hero-banner.basic-interior-hero:not(.hero-banner-form-full-bleed) .hero-banner-body-section {
  border-bottom-width:1px;
}

:host .hero-banner.basic-interior-hero:not(.hero-banner-form-full-bleed) .hero-banner-body-section {
  border-style:solid;
}

:host .hero-banner.basic-interior-hero:not(.hero-banner-form-full-bleed) .hero-banner-body-section {
  border-color:var(--bh-neutral-default);
}

:host .hero-banner.basic-interior-hero:not(.hero-banner-form-full-bleed) .hero-banner-body-section {
  background-color:var(--bh-neutral-white);
}

:host .hero-banner.basic-interior-hero .hero-banner-body-text {
  max-width:900px;
}

:host .hero-banner.basic-interior-hero .hero-banner-breadcrumb {
  margin-bottom:1.5rem;
}

@media (min-width: 1024px) {

  :host .hero-banner.basic-interior-hero .hero-banner-breadcrumb {
    margin-bottom:3rem;
  }
}

:host .hero-banner.basic-interior-hero .hero-banner-title {
  font-size:var(--bh-fs-heading-07);
  line-height:var(--bh-lh-heading-07);
  letter-spacing:var(--bh-ls-heading-07);
}

:host .hero-banner.basic-interior-hero.hero-banner-form-full-bleed .hero-banner-title {
  margin-bottom:3rem;
}

:host .hero-banner.basic-interior-hero .hero-banner-buttons {
  margin-bottom:1.5rem;
}

@media (min-width: 1024px) {

  :host .hero-banner.basic-interior-hero .hero-banner-buttons {
    margin-bottom:3rem;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner.only-title .hero-banner-content-section .hero-banner-body-section {
    padding-bottom:2rem;
  }
}

:host p {
  margin-top:0px;
  margin-bottom:0px;
}

:host p:not(:first-child, :last-child) {
  margin-top:0.25rem;
  margin-bottom:0.25rem;
}

:host [slot='hero-banner-buttons'] {
  display:flex;
}

:host [slot='hero-banner-buttons'] {
  flex-direction:column;
}

:host [slot='hero-banner-buttons'] {
  gap:1.5rem;
}

:host .hero-banner-author {
  margin-bottom:0.75rem;
}

:host .hero-banner-author p:nth-child(2) {
  margin-top:0.75rem;
}

:host .hero-banner-location {
  margin-bottom:0.75rem;
}

:host .hero-banner-date, :host .hero-banner-location, :host .hero-banner-phone-number {
  margin-bottom:0.75rem;
}

:host .hero-banner-date, :host .hero-banner-location, :host .hero-banner-phone-number {
  display:flex;
}

:host .hero-banner-date, :host .hero-banner-location, :host .hero-banner-phone-number {
  align-items:center;
}

:host .hero-banner-date ghs-icon, :host .hero-banner-location ghs-icon, :host .hero-banner-phone-number ghs-icon {
  margin-right:0.75rem;
}

:host .hero-banner-phone-number {
  margin-bottom:0.75rem;
}

:host .hero-banner-phone-number a {
  text-decoration-line:none;
}

:host .hero-banner-phone-number a:hover {
  text-decoration-line:underline;
}

:host .hero-banner-social-icons {
  margin-bottom:0.75rem;
}

:host .hero-banner.hero-banner-form-full-bleed {
  background-color:var(--bh-neutral-white);
}

:host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
  margin-top:-1rem;
}

:host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
  border-top-left-radius:0.75rem;
}

:host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
  border-top-right-radius:0.75rem;
}

:host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
  background-color:var(--neutral-white);
}

:host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
  padding:1rem;
}

@media (min-width: 1024px) {

  :host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
    margin-top:-2rem;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
    padding-top:1.75rem;
    padding-bottom:1.75rem;
  }
}

@media (min-width: 1024px) {

  :host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed) {
    padding-left:3rem;
    padding-right:3rem;
  }
}

:host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed).shadow-lg {
  border-radius:0.75rem;
}

:host .hero-banner-form-wrapper:not(.hero-banner-form-full-bleed).shadow-lg{
      box-shadow:var(--brand-shadow);
    }

:host .hero-banner-details-wrapper {
  margin-bottom:1rem;
}

:host .hidden{
    display:none;
  }

@media (min-width: 1024px){
    :host .lg-hidden{
      display:none;
    }
    :host .lg-flex{
      display:flex;
    }
  }

:host a,
  :host ul,
  :host li{
    color:inherit;
    text-decoration:inherit;
    list-style-type:none;
    margin-left:0;
    padding-left:0;
    margin-block-start:0;
    margin-block-end:0;
    margin-inline-start:0;
    margin-inline-end:0;
    padding-inline-start:0;
  }
`;